import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { unregister } from "./registerServiceWorker";
import { HelmetProvider } from 'react-helmet-async';
import App from "./containers/app/App";
import { PersistGate } from 'redux-persist/lib/integration/react';
import { persistor, store } from './redux/store/';
import reportWebVitals from './reportWebVitals';
import PageLoader from "./components/loader/PageLoader";

window.devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

ReactDOM.render(
    <Provider store={store}>
        <HelmetProvider>
            <PersistGate
                loading={<PageLoader type="spinningBubbles" color="#00b9d7" />}
                persistor={persistor}>
                <App />
            </PersistGate>
        </HelmetProvider>
    </Provider>,
    document.getElementById("root")
);

reportWebVitals();
unregister();
